module.exports = __webpack_public_path__ + "img/de_Ecran 2.2914f01d.png";